import { ReactNode, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { Container as UIContainer } from '@jobtarget/ui-library';
import { useLayout } from '../../context/LayoutContext';
import { Outlet } from 'react-router-dom';

// import '../css/Layout.module.css'


interface ILayout {
  children?: ReactNode;
  userType?: string,
}

const Layout = ({ children, userType="applicant" }: ILayout) => {
  const { 
    title, 
    icon, 
    headerContent, 
    footerContent,
    setTitle
  } = useLayout();

  useEffect(() => {
    if (userType === 'recruiter') {
      setTitle('AI Interviewer');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      position: 'relative',
    }}>
      <div style={{
        flex: '1 0 auto',
      }}>
        {userType === 'recruiter' && <Header />}
        <main className="main-content">
          <UIContainer className="full-height-container ">
            <UIContainer.Header
              icon={
                <img
                  src={icon}
                  alt="Logo"
                  width={32}
                  height={32}
                  style={{ objectFit: 'contain' }}
                />
              }
              title={title}
              
            >
              {headerContent}
            </UIContainer.Header>
            <UIContainer.Body>
              <Outlet />
              {children}
            </UIContainer.Body>
            <UIContainer.Footer>
              {footerContent}
            </UIContainer.Footer>
          </UIContainer>
        </main>
      </div>
      {userType === 'recruiter' && <Footer />}
    </div>
  );
};

export default Layout;